// src/api/session.js
const BASE_URL = 'https://api.ddhyaan.com/api';

function getToken() {
  return localStorage.getItem('token');
}

export async function startSession(goal_name, target_duration_seconds) {
  const res = await fetch(`${BASE_URL}/focus-session/start/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken()}`
    },
    body: JSON.stringify({ goal_name, target_duration_seconds })
  });
  if (!res.ok) throw new Error('Failed to start session');
  return res.json();
}

export async function endSession(focus_session_id, interrupted, notes) {
  const res = await fetch(`${BASE_URL}/focus-session/end/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken()}`
    },
    body: JSON.stringify({ focus_session_id, interrupted, notes })
  });
  if (!res.ok) throw new Error('Failed to end session');
  return res.json();
}

export async function listSessions() {
  const res = await fetch(`${BASE_URL}/focus-session/history/`, {
    headers: {
      'Authorization': `Bearer ${getToken()}`
    }
  });
  if (!res.ok) throw new Error('Failed to fetch sessions');
  return res.json();
}
